<h5>Your Cart is Empty</h5>
<nz-empty nzNotFoundContent="" [nzNotFoundFooter]="footer"></nz-empty>

<ng-template #footer>
  <p>Not sure what to buy?</p>
  @if (isNewArrivals) {
  <p>
    Shop our
    <a
      [routerLink]="['/collection',newArrivalsNo]"
      aria-label="Shop All New Arrivals"
      >New Arrivals</a
    >
  </p>
  }@else{
  <p>
    Shop our
    <a
      [routerLink]="['/collection',bestSellersNo]"
      aria-label="Shop All Best Sellers"
      >Best Sellers</a
    >
  </p>

  }
</ng-template>
